export default __webpack_public_path__ + "static/media/hr&payroll-icon.b5ee09b9.svg";